
import React from 'react';
import { VideoViewer } from "../VideoViewer";

interface VideoContentViewerProps {
  fileUrl: string;
  fileId: string;
  resourceId: string;
  onComplete?: () => void;
  onError?: (error: string) => void;
}

export function VideoContentViewer({
  fileUrl,
  fileId,
  resourceId,
  onComplete,
  onError
}: VideoContentViewerProps) {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <VideoViewer 
        url={fileUrl} 
        fileId={fileId}
        resourceId={resourceId}
        onComplete={onComplete}
        onError={onError}
      />
    </div>
  );
}
